import type { CompetitionPageComponent } from "@/types/competitions";
import { Branding } from "@/components/OfferPage/Branding";
import styles from "./CompetitionPage.module.css";
import { sanitizeTitle } from "@/utils/titleUtils";
import { LandingCarousel } from "@/components/landing/Carousel";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import { GiveawayHero } from "../GiveawayHero/GiveawayHero";
import type { Panel } from "../GiveawayHero/GiveawayHero";
import { getImageUrl } from "@/utils/utils";
import { DynamicForm } from "../landing/DynamicForm";
import { LandingPageTemplateResponse } from "@/types/landing";

export const CompetitionPage: CompetitionPageComponent = ({
    site,
    competitionPage,
    initialViewportWidth,
    userCookie
}) => {
    const { isMobileWidth } = useBreakpoint(768, initialViewportWidth);

    const galleryImages = competitionPage.gallery?.attributes.images.data?.map(
        (image) => {
            return {
                src: image.attributes.url,
                alt: image.attributes.alternativeText ?? '',
            };
        }
    ) ?? [];

    const landingPage = {
        data: {
            attributes: {
                sanitised_form_fields: competitionPage.form_fields,
                fullWidthSubmitButton: true,
                callToActionButtonText: "Unlock Competitions for free",
                offer_page_id: competitionPage.offer_page_id,
                vertical: "competitions"
            }
        }
    } as LandingPageTemplateResponse;

    return (
        <main className={styles["page-container"]}>

            <Branding site={site} />
            <section className={styles["competition-container"]}>
                <div className={styles["competition-grid"]}>
                {isMobileWidth && (
                    <div className={styles["mobile-carousel"]}>
                        <LandingCarousel
                            slides={galleryImages}
                            hideControls={true}
                        />
                    </div>
                )}
                    <div className={styles["goodlife-form"]}>
                        <h2 className={styles["goodlife-title"]}
                            dangerouslySetInnerHTML={{ __html: sanitizeTitle(competitionPage.title)}} />
                        <span className={styles["goodlife-tagline"]}>{competitionPage?.tagline ?? "Tagline here"}</span>
                        <DynamicForm
                            site={site}
                            landingPage={landingPage}
                            userCookie={userCookie}
                        />
                    </div>
                    <div>
                        <LandingCarousel
                            slides={galleryImages}
                            hideImages={isMobileWidth}
                            hideControls={galleryImages.length === 1}
                        />
                    </div>
                </div>
            </section>
            {competitionPage.giveaway_hero && 
             competitionPage.giveaway_hero.heroImage?.data?.attributes?.url && 
             Array.isArray(competitionPage.giveaway_hero.panels) && 
             competitionPage.giveaway_hero.panels.length > 0 && (
                <GiveawayHero
                    logo={site?.attributes?.logo}
                    title={competitionPage.giveaway_hero.title}
                    description={competitionPage.giveaway_hero.description}
                    ctaText={competitionPage.giveaway_hero.ctaText}
                    ctaLink={competitionPage.giveaway_hero.ctaLink}
                    heroImage={{
                        url: getImageUrl(competitionPage.giveaway_hero.heroImage.data.attributes.url),
                        alternativeText: competitionPage.giveaway_hero.heroImage.data.attributes.alternativeText ?? ''
                    }}
                    panels={competitionPage.giveaway_hero.panels}
                />
            )}
        </main>
    );
};

